module.exports = __webpack_public_path__ + "img/avatar-s-17.84190592.jpg";